import { render, staticRenderFns } from "./_AccountSettings.vue?vue&type=template&id=0b098d36&"
import script from "./_AccountSettings.vue?vue&type=script&lang=ts&"
export * from "./_AccountSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports